import type { Context } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const EMBED_PARAM = (ctx: Context, name: string) => {
  const { embedParams = {} } = ctx.globals;
  return embedParams[name] ?? null;
};

export default wrapFunction(EMBED_PARAM, {
  name: 'EMBED_PARAM',
  nargs: 1,
  types: ['string'],
  passContext: true,
});
